module.exports = __webpack_public_path__ + "img/cleanup8-7-8-2021.971e1a74.jpg";